var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.submissionEvidence),function(evidence,index){return _c('p',[(evidence !== null)?[_c('span',{staticClass:"capitalize"},[_vm._v(_vm._s(index.replace('_', ' ')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(evidence)}})]:_vm._e()],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }